/** FIP Wizard: the recommended tool for authoring resources and FIPs. */
export const FIP_WIZARD_URL = 'https://fip.fair-wizard.com'
